import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { ChildrenPropType } from '../../services/proptypes';
var propTypes = {
  children: ChildrenPropType.isRequired
};
var Toggleable = /*#__PURE__*/function (_React$Component) {
  _inherits(Toggleable, _React$Component);
  var _super = _createSuper(Toggleable);
  function Toggleable() {
    var _this;
    _classCallCheck(this, Toggleable);
    _this = _super.call(this);
    _this.state = {
      toggle: false
    };
    return _this;
  }
  _createClass(Toggleable, [{
    key: "onToggle",
    value: function onToggle() {
      this.setState(function (_ref) {
        var toggle = _ref.toggle;
        return {
          toggle: !toggle
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var toggle = this.state.toggle;
      var children = this.props.children;
      return children(toggle, function () {
        return _this2.onToggle();
      });
    }
  }]);
  return Toggleable;
}(React.Component);
export { Toggleable as default };
Toggleable.propTypes = propTypes;